module.exports = __webpack_public_path__ + "static/media/PRIVACY_POLICY.bddb8f2f.md";